import { error } from 'console';

import { countryVendorConfig } from '@porterin/component-library/src/ts-utils/analytics/configs/CountryVendorConfig';
import { Vendors } from '@porterin/component-library/src/ts-utils/analytics/constants/AnalyticsConstants';
import { Countries } from '@porterin/component-library/src/ts-utils/analytics/constants/CountryConstants';
import { JsonHelpers } from '@porterin/component-library/src/ts-utils/analytics/helpers/JsonHelpers';

export const getVendorsForCountry = (country: string): string[] => {
  switch (country) {
    case Countries.UAE:
      return countryVendorConfig.uae;
    case Countries.BD:
      return countryVendorConfig.bd;
    case Countries.TR:
      return countryVendorConfig.tr;
    default:
      return [];
  }
};

export const makeGaPayloadDom = (
  event: string,
  payload?: Record<string, any>,
): Record<string, any> => {
  if (typeof payload === 'object' && payload !== null) {
    return {
      event,
      category: JsonHelpers.extractStringField(payload, 'category'),
      action: JsonHelpers.extractStringField(payload, 'action'),
      value: JsonHelpers.extractNumberField(payload, 'value'),
      label: JsonHelpers.extractStringField(payload, 'label'),
      nonInteraction: JsonHelpers.extractBooleanField(
        payload,
        'nonInteraction',
      ),
      hitType: 'event',
    };
  }
  return { error: 'Invalid payload' };
};

export const makeGaPayloadIntl = (
  event: string,
  payload: Record<string, any>,
): Record<string, any> => {
  // TODO: Implement this
  return {};
};

export const makeMixpanelPayload = (
  event: string,
  payload: Record<string, any>,
): Record<string, any> => {
  // TODO: Implement this
  return {};
};

export const makeMoEngagePayload = (
  event: string,
  payload: Record<string, any>,
): Record<string, any> => {
  // TODO: Implement this
  return {};
};

export const publishGaEvent = (eventPayload: Record<string, any>): void => {
  // TODO: Implement this
};

export const publishMixpanelEvent = (
  eventPayload: Record<string, any>,
): void => {
  // TODO: Implement this
};

export const publishMoEngageEvent = (
  eventPayload: Record<string, any>,
): void => {
  // TODO: Implement this
};

export const makePayload = (
  vendor: string,
  event: string,
  payload: Record<string, any>,
  country: string,
): Record<string, any> => {
  switch (vendor) {
    case Vendors.ga:
      switch (country) {
        case Countries.UAE:
        case Countries.BD:
        case Countries.TR:
          return makeGaPayloadIntl(event, payload);
        default:
          return makeGaPayloadDom(event, payload);
      }
    case Vendors.mixpanel:
      return makeMixpanelPayload(event, payload);
    case Vendors.moEngage:
      return makeMoEngagePayload(event, payload);
    default:
      return {};
  }
};

export const gaCookie =
  typeof document !== 'undefined'
    ? document.cookie.split('; ').find(row => row.startsWith('_ga='))
    : null;
